import { SelectOption } from '../components/Select';

const attachmentsOptions: Array<SelectOption<boolean>> = [
    { label: 'Possui', value: true },
    { label: 'Não possui', value: false },
];

export default attachmentsOptions;
